import ContentGenerationItem from '@/entities/ContentGenerationItem.js';
import ContentGenerationItemPublication from '@/entities/ContentGenerationItemPublication.js';
import api from '@/services/Api';

export default {
  analyzeWebsite(url, contentGoal) {
    const data = { url, content_goal: contentGoal };
    return api().post('/creator-lite/analyze-website', data);
  },

  create(entity, { referenceImage, logo } = {}) {
    const formData = prepareContentGenerationItemEntityToSend(entity, logo, referenceImage);

    return api().post('/creator-lite', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }).then(resp => new ContentGenerationItem(resp));
  },

  getList({ page = 1, limit = 10 } = {}) {
    const data = {};
    if (page) {
      data['page'] = page;
    }
    if (limit) {
      data['limit'] = limit;
    }

    const query = new URLSearchParams(data).toString();
    return api().get('/creator-lite/list?' + query)
      .then(resp => resp.map(item => new ContentGenerationItem(item)));
  },

  get(id) {
    return api().get('/creator-lite/' + id)
      .then(resp => new ContentGenerationItem(resp));
  },

  update(entity, { logo } = {}) {
    const formData = prepareContentGenerationItemEntityToSend(entity, logo);

    return api().post('/creator-lite/' + entity.id, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }).then(resp => new ContentGenerationItem(resp));
  },

  regerenate(
    id,
    {
      visualConcept = false,
      image = false,
      imageText = false,
      textContent = false,
      withNewConcept = false,
    } = {},
  ) {
    const data = {
      visual_concept: visualConcept,
      image,
      image_text: imageText,
      text_content: textContent,
      with_new_concept: withNewConcept,
    };

    return api().post('/creator-lite/' + id + '/regenerate', data)
      .then(resp => new ContentGenerationItem(resp));
  },

  delete(id) {
    return api().delete('/creator-lite/' + id);
  },

  publish(id, targetSourceProfileIds, base64Image) {
    const data = {
      target_source_profiles: targetSourceProfileIds,
      image: base64Image,
    };

    return api().post('/creator-lite/' + id + '/publish', data)
      .then(resp => ({
        item: new ContentGenerationItem(resp.item),
        publications: (resp.publications || []).map(item => new ContentGenerationItemPublication(item)),
      }));
  },
};

function prepareContentGenerationItemEntityToSend(entity, logo = null, referenceImage = null) {
  const ignoredProperties = [
    'id',
    'created_at',
    'updated_at',
    'status',
    'image',
    'owner',
    'visual_idea',
    'visual_prompt',
    'publications',
  ];
  const formData = new FormData();
  if (logo) {
    formData.append('logo_file', logo);
  }
  if (referenceImage) {
    formData.append('reference_image_file', referenceImage);
  }

  const data = entity.toObject();
  (function recoursiveConverter(obj, previousKey = '') {
    for (const [ key, value ] of Object.entries(obj)) {
      if (ignoredProperties.includes(key) || value === null) {
        continue;
      }

      if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        recoursiveConverter(value, previousKey ? `${previousKey}[${key}]` : key);
      }
      else {
        formData.append(previousKey ? `${previousKey}[${key}]` : key, value);
      }
    }
  })(data);

  return formData;
}
